module.exports = __webpack_public_path__ + "img/telemedecine.b9799b51.webp";